module.exports = __webpack_public_path__ + "img/appobyte-icon.3d6445e0.png";